// extracted by mini-css-extract-plugin
module.exports = {"document-modal":"src-components-page-portfolio-portfolio-detail-tab-documents-common-DocumentModal-module__document-modal--kd1N-"};